import { MenuService } from '@shared/services';
import { Menu } from '@shared/models';
import { map } from 'rxjs';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'home-root',
  templateUrl: './home-root.component.html',
  styleUrls: ['./home-root.component.scss']
})
export class HomeRootComponent implements OnInit {
  menu: Menu[];
  @Input() public menuName: string = null;
  menuColumns: string[] = ['L', 'M', 'R'];

  constructor(private menuService: MenuService) { }

  ngOnInit() {
    this.getMenus()
  }

  private getMenus() {
    this.menuService.getChildMenu(null)
      .pipe(
        map((menus) => {
          let filtered = menus.find((menuItem, _) => {
            return menuItem.mencontroller === this.menuName;
          });
          return filtered.menu1;
        })
      ).subscribe((r) => {
        this.menu = r;
      });
  }

  openDialog(controller: string) { }

  filterMenus(column: string): Menu[] {
    return this.menu?.filter(m => m.mencolumn == column);
  }
}
